import { MobileTextInput } from '../../../comps/MobileInput'
import { mobileNumber } from '../../../util/util'

export const formData = (): any => [
  {
    formItems: [
      {
        fieldName: 'mobileNumber',
        ComponentName: MobileTextInput,
        label: 'Mobile Number',
        validationSchema: mobileNumber,
        maxLength: 10,
        inputMode: 'numeric',
        returnKeyType: 'done',
        placeholder: '',
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
